<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  (onHide)="onClose()"
  styleClass="support-ticket-dialog"
>
  <div class="dialog-wrap">
    <div class="dialog-head">
      <div>
        <h3>Report a Bug</h3>
        <p>Help us understand and resolve the issue</p>
      </div>
      <button class="dialog-close" type="button" (click)="closeDialog()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <form [formGroup]="formGroup" class="support-tkt-form">
      <div class="form-field">
        <label>Title*</label>
        <input formControlName="title" placeholder="Enter title" />
      </div>
      <div class="form-field">
        <label>Experiment Link</label>
        <input
          formControlName="experiment_link"
          placeholder="Enter experiment link"
        />
      </div>
      <div class="form-field">
        <label>Description*</label>
        <textarea
          formControlName="description"
          rows="1"
          placeholder="Enter description"
        ></textarea>
      </div>
      <div class="form-field">
        <label>Steps to Reproduce</label>
        <textarea
          formControlName="steps_to_reproduce"
          rows="2"
          placeholder="Enter steps to reproduce"
        ></textarea>
      </div>
      <div class="form-field">
        <label>Impact Level*</label>
        <app-dynamic-dropdown
          [label]="'Impact Level'"
          [options]="impactOptions"
          formControlName="impact_level"
          [optionLabel]="'label'"
          [optionValue]="'value'"
          [isMultiSelect]="false"
          [filter]="false"
        ></app-dynamic-dropdown>
      </div>
      <div class="form-field">
        <label>Attachments</label>
        @if (!fileUploadContent.fileUploadStatus) {
          <app-upload-file
            styleClassName="support-ticket"
            [isMultiple]="true"
            [uploadDataContent]="supportTktStatic.fileUploadContent"
            (actionBrowseButtonCall)="onFileBrowse($event)"
            (actionFileDropCall)="onFileDrop($event)"
          ></app-upload-file>
        } @else {
          <div class="uploaded-files-preview">
            <img
              width="43px"
              src="/assets/images/icon-file-upload-completed.svg"
            />
            <span>{{ fileUploadContent.fileList.length }} files selected</span>
            <i class="pi pi-times-circle" (click)="clearFileSelection()"></i>
          </div>
        }
        @if (fileUploadContent.fileUploadError) {
          <small class="dialog-error">{{
            fileUploadContent.fileUploadError
          }}</small>
        }
      </div>
    </form>

    <div class="dialog-actions">
      <button
        class="btn-outline"
        type="button"
        [disabled]="showDialogLoader"
        (click)="closeDialog()"
      >
        Cancel
      </button>
      <button
        class="btn-dark"
        type="button"
        [disabled]="showDialogLoader || formGroup.invalid"
        (click)="onFormSubmit()"
      >
        {{ showDialogLoader ? "Submitting..." : "Submit" }}
      </button>
    </div>
  </div>
</p-dialog>
